module.exports = __webpack_public_path__ + "assets/images/magenta_sport_4k.b0236d2912379599347596b87b5a80ff.png";